package org.example.project.enginekartei

import androidx.compose.runtime.Composable
import org.example.project.settings.AppDropdown
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.example.project.utils.All
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.css.*

@Composable
fun <E> EngineKarteiHeaderBar(
    entities: List<E>,
    selectedEntityId: String,
    onEntityChange: (String) -> Unit,
    onSave: () -> Unit,
    secondaryAction: EngineKarteiPageAction? = null,
    onSecondaryAction: () -> Unit = {},
    showSave: Boolean,
    saveEnabled: Boolean,
    saving: Boolean,
    onCreateNew: () -> Unit,
    entityId: (E) -> String,
    entityLabel: (E) -> String,
    selectorWidthPx: Int = 320,
    showCreate: Boolean = true,
    selectorContent: (@Composable (activePageId: String) -> Unit)? = null,
    actionContent: (@Composable (activePageId: String) -> Unit)? = null,
    activePageId: String = "",
    centerContent: @Composable () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.SpaceBetween)
            gap(16.px)
            paddingBottom(12.px)
        }
    }) {
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.FlexStart)
                property("flex", "0 0 ${selectorWidthPx}px")
                minWidth(0.px)
            }
        }) {
            if (selectorContent != null) {
                selectorContent(activePageId)
            } else {
                AppDropdown(
                    options = entities.map { item ->
                        val id = entityId(item)
                        All(key = id, label = entityLabel(item).ifBlank { id })
                    },
                    selectedValue = selectedEntityId.takeIf { it.isNotBlank() },
                    onChange = { if (it.isNotBlank()) onEntityChange(it) },
                    placeholder = "Auswahl",
                    attrs = { style { width(selectorWidthPx.px); height(40.px) } }
                )
            }
        }

        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                property("flex", "1 1 auto")
                minWidth(0.px)
                width(100.percent)
            }
        }) {
            centerContent()
        }

        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.FlexEnd)
                gap(10.px)
                property("flex", "0 0 auto")
                minWidth(0.px)
            }
        }) {
            if (actionContent != null) {
                actionContent(activePageId)
            }

            if (secondaryAction != null) {
                LumaticaButton(
                    label = secondaryAction.label,
                    onClick = { onSecondaryAction() },
                    variant = LumaticaButtonVariant.Standard,
                    enabled = !saving,
                    heightPx = 40,
                    paddingH = 12,
                    content = {
                        Img(src = "images/lock_reset.svg", attrs = {
                            style {
                                width(18.px)
                                height(18.px)
                            }
                        })
                    }
                )
            }

            if (showSave) {
                LumaticaButton(
                    label = if (saving) "Speichern..." else "Speichern",
                    onClick = { onSave() },
                    variant = LumaticaButtonVariant.Action,
                    enabled = saveEnabled,
                    heightPx = 40,
                    paddingH = 12,
                    content = {
                        Img(src = "images/save.svg", attrs = {
                            style {
                                width(18.px)
                                height(18.px)
                            }
                        })
                    }
                )
            }

            if (showCreate) {
                LumaticaButton(
                    label = "Neu",
                    onClick = { onCreateNew() },
                    variant = LumaticaButtonVariant.Standard,
                    heightPx = 40,
                    paddingH = 12,
                    content = {
                        Img(src = "images/add.svg", attrs = {
                            style {
                                width(18.px)
                                height(18.px)
                            }
                        })
                    }
                )
            }
        }
    }
}
